// DS: i5.3
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const FavStar: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <path d="M8.562 1c.277 0 .536.144.7.384l.058.095 1.425 2.675 3.174.474c.29.043.539.241.668.524l.043.11.32.993c.104.326.042.686-.157.945l-.081.093-2.229 2.226.546 3.152c.059.336-.05.678-.278.901l-.092.078-.913.683a.81.81 0 0 1-.77.118l-.109-.049-2.863-1.529-2.807 1.515a.81.81 0 0 1-.774 0l-.102-.063-.943-.692a1 1 0 0 1-.39-.85L3 12.654l.522-3.136-2.235-2.234c-.23-.23-.33-.572-.271-.9l.029-.123.31-1.008a.92.92 0 0 1 .606-.624l.108-.025 3.164-.471 1.423-2.657a.88.88 0 0 1 .656-.47L7.415 1zM6.313 5.995 3 6.485l2.419 2.4-.6 3.572.043.031 3.146-1.687 3.201 1.699.015-.012-.625-3.596L13 6.507l-3.32-.492L8.065 3h-.14z"></path>
    </svg>
  </IconWrap>
);
FavStar.displayName = 'FavStar';

export default FavStar;
